import React, { useState, useEffect } from "react";
import { IoCloseCircle } from "react-icons/io5";
import { getDelawareDate } from "../env";

import "./style.css";

export default function PopUp3({ closePopUp, studentList, startDate,selectedStudent, setSelectedStudent,selectedMonth, setSelectedMonth,navigateToReport,setSelectedStudentName}) {
   
    const [monthsOptions, setMonthsOptions] = useState([]);

    // Function to generate months list
    function generateMonthsList(inputDate) {
        const [inputYear, inputMonth] = inputDate.split("-");
        const delawareDate = getDelawareDate();
        const [currentYear, currentMonth] = delawareDate.split("-");

        const monthsList = [];
        for (let year = parseInt(inputYear); year <= parseInt(currentYear); year++) {
            const startMonth = year === parseInt(inputYear) ? parseInt(inputMonth) : 1;
            const endMonth = year === parseInt(currentYear) ? parseInt(currentMonth) : 12;

            for (let month = startMonth; month <= endMonth; month++) {
                const formattedMonth = month.toString().padStart(2, "0"); // Ensure 2-digit month format
                monthsList.push({
                    label: `${new Date(year, month - 1).toLocaleString("en-US", {
                        month: "long",
                        year: "numeric",
                    })}`,
                    value: `${year}-${formattedMonth}`,
                });
            }
        }
        return monthsList;
    }

    // Populate months list when the component mounts or when startDate changes
    useEffect(() => {
        if (startDate) {
            const monthsList = generateMonthsList(startDate);
            setMonthsOptions(monthsList);
            console.log(startDate,"here is date",monthsList);
        }
    }, [startDate]);

    const handleStudentChange = (event) => {
        const selectedOption = event.target.selectedOptions[0]; // Get the selected <option>
        const selectedValue = selectedOption.value; // Extract the value
        const selectedLabel = selectedOption.label; // Extract the label
    
        setSelectedStudent(selectedValue);
        setSelectedStudentName(selectedLabel);
    };
    
    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
        console.log("Selected Month:", event.target.value);
    };

    return (
        <div className="popup">
            <div className="popupContainer">
                {/* Student Dropdown */}
                <div className="dropdown_container">
                    <label htmlFor="studentDropdown">Select Teacher</label>
                    <select
                        id="studentDropdown"
                        value={selectedStudent}
                        onChange={handleStudentChange}
                    >
                        <option value="" disabled>
                            -- Select a Teacher --
                        </option>
                        {studentList &&
                            studentList.map((student) => (
                                <option key={student.id} value={student.value}>
                                    {student.label}
                                </option>
                            ))}
                    </select>
                </div>

                {/* Month Dropdown */}
                <div className="dropdown_container">
                    <label htmlFor="monthDropdown">Select Month</label>
                    <select
                        id="monthDropdown"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                    >
                        <option value="" disabled>
                            -- Select a month --
                        </option>
                        {monthsOptions.map((month) => (
                            <option key={month.value} value={month.value}>
                                {month.label}
                            </option>
                        ))}
                    </select>
                </div>

                <button onClick={()=>{navigateToReport()}}>See Monthly Report</button>
                <div onClick={closePopUp} className="close_container">
                    <IoCloseCircle />
                </div>
            </div>
        </div>
    );
}
